import { render, staticRenderFns } from "./AppFoot.vue?vue&type=template&id=11378139&scoped=true"
import script from "./AppFoot.vue?vue&type=script&lang=js"
export * from "./AppFoot.vue?vue&type=script&lang=js"
import style0 from "./AppFoot.vue?vue&type=style&index=0&id=11378139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11378139",
  null
  
)

export default component.exports